module.exports = __webpack_public_path__ + "media/images/summit-4-c1cef81f0de96a7201a94da31de91927.jpg";